import type { MenuPage } from '@/content/printMenu/types'

export type BookletSpread =
  | {
      type: 'solo'
      pages: [MenuPage]
      startPageNumber: number
    }
  | {
      type: 'spread'
      pages: [MenuPage, MenuPage]
      startPageNumber: number
      /** True when the spread has a blank right leaf for an odd interior page count. */
      padRight?: boolean
    }

/**
 * Groups menu pages for on-screen booklet preview:
 * cover alone, interior as left/right spreads, back cover alone.
 */
export function buildBookletSpreads(pages: MenuPage[]): BookletSpread[] {
  if (pages.length === 0) return []

  const spreads: BookletSpread[] = [
    { type: 'solo', pages: [pages[0]], startPageNumber: 1 },
  ]

  const interior = pages.slice(1, -1)
  for (let i = 0; i < interior.length; i += 2) {
    const left = interior[i]
    const right = interior[i + 1]
    const startPageNumber = i + 2

    if (right) {
      spreads.push({ type: 'spread', pages: [left, right], startPageNumber })
    } else {
      spreads.push({
        type: 'spread',
        pages: [left, { kind: 'blank' }],
        startPageNumber,
        padRight: true,
      })
    }
  }

  if (pages.length > 1) {
    spreads.push({
      type: 'solo',
      pages: [pages[pages.length - 1]],
      startPageNumber: pages.length,
    })
  }

  return spreads
}
